// layouts/DashboardLayout/DashboardLayout.tsx
import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import Header from './components/Header/Header';
import OnboardingTour from '../../components/common/OnboardingTour/OnboardingTour';
import styles from './DashboardLayout.module.css';
import { useAuth } from '../../contexts/AuthContext';
import Modal from '../../components/common/Modal/Modal';
import { User } from '../../Entities';
import { notify } from '../../components/common/Toast/toastBridge';

const DashboardLayout = () => {
  const { user, setUser } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [isNoticeOpen, setIsNoticeOpen] = useState<boolean>(!!user?.notice);
  const [processing, setProcessing] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const toggleSidebar = () => setIsSidebarOpen(o => !o);
  const closeSidebar = () => setIsSidebarOpen(false);

  const hideNotice = async () => {
    if (!user || processing) return;
    try {
      setProcessing(true);
      const updatedUser = new User(user);
      updatedUser.notice = null;
      await updatedUser.update();
      setUser(updatedUser);
    } catch (error) {
      console.error(error);
    } finally {
      setProcessing(false);
      setIsNoticeOpen(false);
    }
  };

  if (!user) return null;

  return (
    <div className={styles.layout}>
      {isSidebarOpen && <div className={styles.overlay} onClick={closeSidebar} />}
      <OnboardingTour />
      <Modal title="Upozornění" isOpen={isNoticeOpen} onClose={hideNotice}>
        <p>{user.notice}</p>
      </Modal>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div className={styles.mainContent}>
        <Header onMenuToggle={toggleSidebar} />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
